import { render, staticRenderFns } from "./contact-block.vue?vue&type=template&id=566b1abc&"
import script from "./contact-block.vue?vue&type=script&lang=js&"
export * from "./contact-block.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./contact-block.vue?vue&type=custom&index=0&blockType=i18n&lang=yaml"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {UiTagline: require('/app/components/ui/tagline.vue').default,FormsContact: require('/app/components/forms/contact.vue').default,UiTransition: require('/app/components/ui/transition.vue').default})
